// extracted by css-extract-rspack-plugin
export default {"progress-bar":"BiddingStrategySelectBottomPanel-module__progress-bar--QB37h","progressBar":"BiddingStrategySelectBottomPanel-module__progress-bar--QB37h"};